import app from './app';
import auth from './auth';
import user from './user';

export default {
    app,
    auth,
    user
}